export const ErrorCodes = {
  // API
  API_001: "API_001", // Network request failed (fetch threw)
  API_002: "API_002", // Non-2xx HTTP response
  API_003: "API_003", // Response parsing failed (bad JSON/proto)
  API_004: "API_004", // Request timeout

  // Wallet
  WALLET_001: "WALLET_001", // Wallet connection failed
  WALLET_002: "WALLET_002", // Transaction signing rejected by user
  WALLET_003: "WALLET_003", // Transaction broadcast failed
  WALLET_004: "WALLET_004", // Insufficient balance

  // WalletConnect
  WC_001: "WC_001", // WalletConnect session creation failed
  WC_002: "WC_002", // WalletConnect session expired/disconnected
  WC_003: "WC_003", // WalletConnect request timeout

  // UI
  UI_001: "UI_001", // React error boundary caught a crash

  // Redux
  REDUX_001: "REDUX_001", // Async thunk rejected
  REDUX_002: "REDUX_002", // Invalid state transition

  // Unknown
  UNKNOWN_001: "UNKNOWN_001", // Uncategorized error
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
